import { Autocomplete, createFilterOptions, TextField } from '@mui/material';
import { ExpandMoreOutlined } from '@mui/icons-material';
import colors from '../../../../../scss/colors';
import { textFieldStyles } from '../../../expense/components/MainTable/helper';

const filter = createFilterOptions();

export const ApproverSelectionComponent = ({
  t,
  section,
  approver,
  setOpenPop,
  setApprover,
  changeHandler,
  onClickHandler,
  approvers
}) => {
  return (
    <Autocomplete
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        filtered.push({
          label: t('common.general.requestNewApprover'),
          isCustomAction: true
        });
        return filtered;
      }}
      disableClearable
      slotProps={{
        popper: {
          sx: {
            zIndex: 9999
          }
        }
      }}
      value={approvers?.find((item) => item.value === section?.ApproverId) || approver || null}
      options={Array.isArray(approvers) ? approvers : []}
      sx={{
        '& .MuiSvgIcon-root': { color: '#D1D3D4', fontSize: '24px' },
        '& .MuiFormControl-fullWidth': { width: '100%' },
        width: '100%',
        border: `1px solid ${colors.LIGHT_GREY}`,
        borderRadius: '10px',
        background: 'white'
      }}
      isOptionEqualToValue={(option, value) => option?.label === value?.label}
      popupIcon={<ExpandMoreOutlined />}
      forcePopupIcon
      onChange={(event, newValue) => {
        if (newValue && newValue.isCustomAction) {
          setOpenPop('requestNewApprover');
        } else {
          changeHandler(newValue, section?.Id, section);
          setApprover(newValue);
        }
      }}
      onClick={onClickHandler}
      getOptionLabel={(option) => option?.label || ''}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={`${t('dashboard.createtimesheet.steps.selectapprover')}*`}
          sx={textFieldStyles('400px')}
        />
      )}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <li
            key={key}
            {...optionProps}
            className={
              option.isCustomAction
                ? `${optionProps.className} text-md cursor-pointer font-bold border-t border-gray-300 hover:!bg-navy-blue hover:text-white text-navy-blue`
                : `${optionProps.className} px-3 cursor-pointer text-md py-3 hover:bg-gray-100 border-l-2 border-l-transparent hover:border-l-navy-blue text-navy-blue`
            }
          >
            {option.label}
          </li>
        );
      }}
    />
  );
};
